import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import dayjs from 'dayjs';

export interface WeeklyMetrics {
  urgentRiskCount: number;
  highRiskCount: number;
  totalMonitoredCount: number;
  koreanRiskCount: number;
}

interface WeeklyReportState {
  lastFetched: string | null;
  currentCalendarWeek: string | null;
  weeklyMetrics: WeeklyMetrics[];
  setWeeklyData: (
    data: {
      thisWeek: WeeklyMetrics;
      lastWeek: WeeklyMetrics;
      twoWeeksAgo: WeeklyMetrics;
      threeWeeksAgo: WeeklyMetrics;
    },
    calendarWeek: string
  ) => void;
  getWeekData: (weekOffset: number) => WeeklyMetrics;
}

const defaultWeeklyMetrics: WeeklyMetrics = {
  urgentRiskCount: 0,
  highRiskCount: 0,
  totalMonitoredCount: 0,
  koreanRiskCount: 0,
};

const useWeeklyReportStore = create<WeeklyReportState>()(
  persist(
    (set, get) => ({
      lastFetched: null,
      currentCalendarWeek: null,
      weeklyMetrics: Array(4).fill(defaultWeeklyMetrics),
      setWeeklyData: (data, calendarWeek) => {
        set({
          weeklyMetrics: [
            data.thisWeek,
            data.lastWeek,
            data.twoWeeksAgo,
            data.threeWeeksAgo,
          ],
          currentCalendarWeek: calendarWeek,
          lastFetched: dayjs().toISOString(),
        });
      },
      getWeekData: (weekOffset: number) => {
        const state = get();
        return state.weeklyMetrics[weekOffset] || defaultWeeklyMetrics;
      },
    }),
    {
      name: 'weekly-report-storage',
    }
  )
);

export default useWeeklyReportStore;
